import { MMKV } from 'react-native-mmkv';
import { StateStorage } from 'zustand/middleware';

export const mmkvFF4JPersistence = new MMKV({
  id: 'mmkvFF4JPersistence',
});

export const zustandFF4JStorage: StateStorage = {
  setItem(name: string, value: string) {
    return mmkvFF4JPersistence.set(name, value);
  },
  getItem(name: string) {
    const value = mmkvFF4JPersistence.getString(name);
    return value ?? null;
  },
  removeItem(name: string) {
    return mmkvFF4JPersistence.delete(name);
  },
};
